import { SavedSelection } from '@pages/Home/context/TerritorySelectionContext';
import { TerritoryOption } from '@apiHooks/useTerritoryOptions';

interface BuildSummaryTextOptions {
    states: TerritoryOption[];
    metros: TerritoryOption[];
}

export const TOTAL_US_LABEL = 'Total US';

export function buildSummaryText(
    saved: SavedSelection | null,
    options: BuildSummaryTextOptions
): string {
    if (!saved || saved.ids.length === 0) return TOTAL_US_LABEL;

    const pool = saved.mode === 'state' ? options.states : options.metros;
    const poolMap = new Map(pool.map(o => [o.id, o.label]));

    const labels = saved.ids
        .map(id => poolMap.get(id))
        .filter((label): label is string => label !== undefined);

    return labels.join(', ');
}
